<ui-modal
  class="save-strategy"
  [isOpened]="isModalOpened"
  modalTitle="Save Strategy"
  (isOpenedChange)="modalChanged($event)"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="save-strategy__input-container">
      <label class="clr-control-label">Name</label>
      <clr-input-container>
        <input clrInput formControlName="name" type="text" />
      </clr-input-container>
    </div>
    <div class="modal-footer">
      <div class="saving">
        <loading-spinner *ngIf="savingInfo === 'Saving'"></loading-spinner>
        <div
          *ngIf="savingInfo === 'Saved' || savingInfo === 'Failed'"
          [ngClass]="savingInfo === 'Saved' ? 'success' : 'failed'"
        >
          {{ savingInfo }}
        </div>
      </div>
      <button
        class="ui-button primary"
        type="submit"
        [ngClass]="this.form.valid ? 'ng-valid' : 'ng-invalid'"
        [disabled]="!this.form.valid"
        [style.cursor]="!this.form.valid ? 'not-allowed' : 'default'"
      >
        Save
      </button>
    </div>
  </form>
</ui-modal>
